import React from 'react';

interface ImageViewerProps {
  url: string;
}

const ImageViewer: React.FC<ImageViewerProps> = ({ url }) => {
  return (
    <div style={{ 
      width: '100vw', 
      height: '100vh', 
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: '#000000',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <img
        src={url}
        alt="Shared Image"
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain'
        }}
      />
    </div>
  );
};

export default ImageViewer;
